import styled from 'styled-components';

const MediaGalleryWrapper = styled.section`
  margin-top: 4rem;
  
  h2 {
    text-transform: none;
  }

  h4 {
    font-weight: 700;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    text-align: center;
    color: var(--primary-color);
  }

  .media-gallery {
    display: grid;
    justify-content: center;
    gap: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); 
    max-width: 1200px; 
    margin: 0 auto;

  }

  .btnLink {
    background-color: 'red';
  }

  .media-card {
    background-color: var(--background-secondary-color); 
    max-width: 400px; 
    width: 100%;
    height: auto;
    margin: 0 auto;
    border-radius: 10px; 
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    color: var(--primary-color);
  }

  .media-image {
    width: 100%;
    height: 250px;
    object-fit: cover; 
    border-radius: 10px 10px 0 0; 
  }

  .typography {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    
  }
`;

export default MediaGalleryWrapper;
